/**
 * @generated SignedSource<<367e681023ee0eba14c70adcee5b4a97>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CalendarSource = "google" | "internal" | "office365";
export type UserPreferencesResyncCalendarsListMutation$variables = {
  source: CalendarSource;
};
export type UserPreferencesResyncCalendarsListMutation$data = {
  readonly resyncCalendarsList: {
    readonly error: {
      readonly service: string | null;
    } | null;
    readonly viewer: {
      readonly calendars: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly color: string | null;
            readonly hadErrorOnSync: boolean | null;
            readonly id: string;
            readonly lastSyncDatetime: string | null;
            readonly name: string | null;
            readonly removedFromApi: boolean | null;
            readonly source: CalendarSource;
            readonly sourcePrimary: boolean;
            readonly syncEnabled: boolean;
          };
        }>;
      };
      readonly id: string;
    };
  } | null;
};
export type UserPreferencesResyncCalendarsListMutation = {
  response: UserPreferencesResyncCalendarsListMutation$data;
  variables: UserPreferencesResyncCalendarsListMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "source"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "source",
        "variableName": "source"
      }
    ],
    "concreteType": "ResyncCalendarsList",
    "kind": "LinkedField",
    "name": "resyncCalendarsList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReauthError",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "service",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarConnection",
            "kind": "LinkedField",
            "name": "calendars",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CalendarEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Calendar",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "source",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sourcePrimary",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "syncEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "removedFromApi",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastSyncDatetime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hadErrorOnSync",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserPreferencesResyncCalendarsListMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserPreferencesResyncCalendarsListMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "942703626fc63aea2da6ef7bfb4388b4",
    "id": null,
    "metadata": {},
    "name": "UserPreferencesResyncCalendarsListMutation",
    "operationKind": "mutation",
    "text": "mutation UserPreferencesResyncCalendarsListMutation(\n  $source: CalendarSource!\n) {\n  resyncCalendarsList(source: $source) {\n    error {\n      service\n    }\n    viewer {\n      id\n      calendars {\n        edges {\n          node {\n            id\n            name\n            source\n            sourcePrimary\n            syncEnabled\n            removedFromApi\n            color\n            lastSyncDatetime\n            hadErrorOnSync\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "05e991836a2432e3018878e98ed11930";

export default node;
